import React, { useMemo } from 'react';
import { withNativeProps } from '@/utils/with-native-props';
import cx from 'classnames';
const SkeletonParagraph = (props) => {
    const { lineCount = 1, animated } = props;
    const itemCls = cx({
        'cn-ui-m-skeleton-paragraph-item': true,
        'cn-ui-m-skeleton-paragraph-item-animation': animated,
    });
    const list = useMemo(() => {
        const data = [];
        for (let i = 0; i < lineCount; i++) {
            data.push(i);
        }
        return data;
    }, [lineCount]);
    return withNativeProps(props, React.createElement("div", { className: "cn-ui-m-skeleton-paragraph" }, list.map(() => (React.createElement("div", { className: itemCls })))));
};
export default SkeletonParagraph;
